<mat-form-field
  data-at-form-field
  mat-select-height-small
  *ngIf="options && options.length"
  [style.width]="width"
>
  <mat-select
    [placeholder]="placeholder"
    [disabled]="disabled"
    [ngModel]="option"
    (ngModelChange)="onChange($event)"
    fieldTextContentTooltip
  >
    <mat-option
      data-at-option
      fieldTextContentTooltip
      *ngFor="let opt of options"
      [value]="opt.value"
      >{{ opt.name }}</mat-option
    >
  </mat-select>
</mat-form-field>
